import { Stack, Text } from '@mantine/core';
import { ReactNode, Suspense } from 'react';

import { Paper } from '@/module/Author/Paper/model/PaperTypes';

import { Content, PendingSpinner } from '@/core/components';

import { JournalLink, JournalVolume } from '@feature/utils';

interface PaperContentProps {
  paper: Paper;
  metrics: ReactNode;
}

export function PaperContent({ paper, metrics }: PaperContentProps) {
  const { journal, volume, volumeNo, noOfPages, endPage, startPage, journalType } = paper;
  return (
    <Content type="full">
      <Stack>
        <JournalLink
          journalId={journal.id}
          title={journal.title}
        />
        {journalType && <Text>Tip revista: {journalType.name}</Text>}
        <JournalVolume
          volume={volume}
          volumeNo={volumeNo}
          noOfPages={noOfPages}
          endPage={endPage}
          startPage={startPage}
        />
      </Stack>
      <Suspense fallback={<PendingSpinner h="60px" />}>{metrics}</Suspense>
    </Content>
  );
}
